/**
 * Created by eliranm on 14/12/14.
 */
define(function (require) {
    'use strict';

    var LE = require('app');
    var BaseModel = require('models/BaseModel');

    var KEYS = {
        mode: 'mode'
    };

    var ContentImportCommandModel = {};
    LE.module('LEContent', function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentImportCommandModel = BaseModel.extend({
            name: "ContentImportCommandModel",
            defaults: {
                mode: 'foreground'
            },

            reset: function () {
                this.clear().set(this.defaults);
            },

            setMode: function (mode) {
                this.set(KEYS.mode, mode);
            },

            getMode: function () {
                return this.get(KEYS.mode);
            }

        });
    });

    ContentImportCommandModel.KEYS = KEYS;

    return ContentImportCommandModel;
});
